
        import 'Spinner.d03a67d.css-module'
        export default {"Spinner":"Spinner_Spinner_d03a67d","pulse":"pulse_Spinner_d03a67d"}
    